<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-6">
            <a @click="openPage('/memberEntry/edit?id=' + $route.query.member_id)" class="btn-grey"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
          </div>
          <div class="col-md-6 text-right">
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <div class="row justify-content-center mt-30">
          <div class="col-sm-10">
            <form @submit.prevent="submitData">
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Date</label>
                </b-col>
                <b-col sm="10">
                  <flat-pickr :config="config" v-model="editData.created_at" name="date" class="w-100"></flat-pickr>
                  <span class="error">{{ errors.first('date') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Attendance Type</label>
                </b-col>
                <b-col sm="10">
                  <b-form-select name="attendance_type" v-model="editData.attendance_type_id">
                    <option :value="null">Please select</option>
                    <option :value="1">From Membership</option>
                    <option :value="2">From Package</option>
                  </b-form-select>
                  <span class="error">{{ errors.first('attendance_type') }}</span>
                </b-col>
              </b-row>
              <div class="text-right">
                <button type="submit" class="btn-primary">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import moment from 'moment'

export default {
  name: 'addSales',
  data: function () {
    return {
      dataBranch: [],
      changePassData: {
        old_password: '',
        new_password: '',
        confirm_password: ''
      },
      editData: {
        attendance_type_id: '',
        created_at: '',
      },
      config: {
        altInput: true,
        altFormat: 'j F Y H:i',
        dateFormat: 'Y-m-d H:i',
        enableTime: true,
        enableSeconds: true,
        time_24hr: true
      },
      confirm_password: '',
      imageData: '',
      imgUpload: null,
      salesRole: '',
      branchSalesId: '',
      file: null,
      options: [
        { value: null, text: 'Please select' },
        { value: 'active', text: 'Active' },
        { value: 'inactive', text: 'Inactive' }
      ]
    }
  },
  methods: {
    submitData () {
      this.$validator.validateAll().then((result) => {
        if(result) {
          axios.put('fitness/v1/member_gym_attendance/' + this.$route.query.id, this.editData).then(response => {
            // console.log('test', response)
            this.$router.push('/memberEntry/edit?id=' + this.$route.query.member_id)
            this.$toast.success('data saved successfully!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          }).catch(error => {
            // console.log('error log', error)
            this.$toast.success('cant saved data!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          })
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    openPage (event) {
      this.$router.push(event)
    },
    previewImage: function(event) {
        // Reference to the DOM input element
        var input = event.target;
        // Ensure that you have a file before attempting to read it
        if (input.files && input.files[0]) {
            // create a new FileReader to read this image and convert to base64 format
            var reader = new FileReader();
            // Define a callback function to run, when FileReader finishes its job
            reader.onload = (e) => {
                // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                // Read image as base64 and set to imageData
                this.imageData = e.target.result;
            }
            // Start the reader job - read file as a data url (base64 format)
            reader.readAsDataURL(input.files[0]);
        }
    },
    fetchData() {
      axios.get('fitness/v1/member_gym_attendance/' + this.$route.query.id).then(response => {
        // console.log(response.data.data)
        this.editData.attendance_type_id = response.data.data.attendance_type_id
        this.editData.created_at = response.data.data.created_at
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()
  }
}
</script>

<style>
</style>
